import { ModuleWithProviders, Type } from '@angular/core';
import { Routes } from '@angular/router';

// Core
export * from 'src/environments/server';
export * from 'src/core/index';

export * from 'src/index/components.index';
import { CoreFooterComponent } from 'src/index/components.index';

import { AppModuleConfig, User as UserCore } from 'src/core/index';
import { LocalizationModule } from 'src/core/index/shared.module.index';
import { AppRoutingModule } from 'src/custom/app-routing.module';

// Core - Optional modules
// import { BotSearchModule } from 'src/core/index';
import { ChatModule } from 'src/core/index'; // TEMP disabilitato
import { CoursesModule } from 'src/core/index';
import { DashboardModule } from 'src/core/index';
import { GlobalSearchModule } from 'src/core/index';
// import { GuidesModule } from 'src/core/index'; // TEMP disabilitato
import { HelpModule } from 'src/core/index';
import { LoginModule } from 'src/core/index';
import { MyCoursesModule } from 'src/core/index';
// import { MyGuidesModule } from 'src/core/index';
import { GdprModule } from 'src/core/index';
// import { PublicModule } from 'src/core/index';
import { RegistrationModule } from 'src/core/index';
// import { SelfAssessmentModule } from 'src/core/index';
import { UserProfileModule } from 'src/core/index';
import { ViewerModule } from 'src/core/index';
// import { PresentationViewerModule } from 'src/core/index';
// import { ArModule } from 'src/core/index';
// import { TeachersModule } from 'src/core/index';
import { GlobalCalendarModule } from 'src/core/index';

// Configurazione d'ambiente
export * from 'src/environments/environment';
export * from 'src/environments/platform';

// Moduli opzionali che possono essere attivati o disattivati. Per disattivare, basta commentare la riga di riferimento e la relativa riga nella definizione delle rotte
const optionalModules: (any[] | Type<any> | ModuleWithProviders<{}>)[] = [
    // BotSearchModule,
    CoursesModule,
    ChatModule,
    DashboardModule,
    GdprModule,
    GlobalSearchModule,
    // GuidesModule, // TEMP disabilitato
    HelpModule,
    LoginModule,
    MyCoursesModule,
    // MyGuidesModule,
    // PublicModule,
    RegistrationModule,
    // SelfAssessmentModule,
    UserProfileModule,
    // TeachersModule,
    ViewerModule,
    // PresentationViewerModule,
    // ArModule,
    GlobalCalendarModule,
];
const optionalRoutes: Routes = [
    // ...BotSearchModule.prototype.getRoutes(),
    ...ChatModule.prototype.getRoutes(),
    ...CoursesModule.prototype.getRoutes(),
    ...DashboardModule.prototype.getRoutes(),
    ...GdprModule.prototype.getRoutes(),
    ...GlobalSearchModule.prototype.getRoutes(),
    // ...GuidesModule.prototype.getRoutes(), // TEMP disabilitato
    ...HelpModule.prototype.getRoutes(),
    ...LoginModule.prototype.getRoutes(),
    ...MyCoursesModule.prototype.getRoutes(),
    // ...MyGuidesModule.prototype.getRoutes(),
    // ...PublicModule.prototype.getRoutes(),
    ...RegistrationModule.prototype.getRoutes(),
    // ...SelfAssessmentModule.prototype.getRoutes(),
    ...UserProfileModule.prototype.getRoutes(),
    ...ViewerModule.prototype.getRoutes(),
    // ...PresentationViewerModule.prototype.getRoutes(),
    // ...ArModule.prototype.getRoutes(),
    // ...TeachersModule.prototype.getRoutes(),
    ...GlobalCalendarModule.prototype.getRoutes(),
];

// Aggiungere componenti ad AppModule
export const appModuleConfig: AppModuleConfig = {
    declarations: [
      CoreFooterComponent,
    ],
    imports: [
        ...optionalModules,
    ],
    providers: [],
    routes: [
        // Controllo su effettivo bisogno di rotte per la localizzazione interno a LocalizationModule.prototype.getRoutes
        ...LocalizationModule.prototype.getRoutes([ // "Vincono" le rotte definite per prime. Per fare override di una rotta, basta definirla nel proprio routing module con lo stesso path
            ...AppRoutingModule.prototype.getRoutes(),
            ...optionalRoutes,
        ]),
        { path: '**', redirectTo: '', pathMatch: 'full' }
    ],
};

export interface User extends UserCore {
  sector?: string;
}
